import React, { useCallback, useState } from 'react'
import { RankIndexTabs } from '~/components/business/RankIndexTabs'
import IndexRank from '~/components/pages/rank/IndexRank'
import {
  indexTabList,
  RANK_TAB_TYPE,
  TabsItemProps,
  INDEX_RANK_ITEM_LIST_TYPE,
} from '~/components/pages/rank/hooks'
import {
  aiCreatorsTabList,
  useAiCreators,
} from '~/components/pages/rank/hooks/useAiCreators'
import { useCreators } from '~/components/pages/rank/hooks/useCreators'
import { useWorks } from '~/components/pages/rank/hooks/useWorks'
import { useCollections } from '~/components/pages/rank/hooks/useCollections'

import {
  ArtworkCommonSortPeriod,
  ArtworkCommonSortType,
  QueryDateEnum,
  getAiSameStyleRank_copyrightStatisticsModule_aiCreatorsList_edges_node,
  getAiPictureCountRank_copyrightStatisticsModule_aiCreatorsList_edges_node,
  getAiFansCountRank_copyrightStatisticsModule_aiCreatorsList_edges_node,
} from '~/graphqls/types'

const defaultParams = {
  first: 3,
  offset: 0,
}

export const RankListModule: React.FC<{
  data: {
    aiSameRankList: getAiSameStyleRank_copyrightStatisticsModule_aiCreatorsList_edges_node[]
    aiPictureRankList: getAiPictureCountRank_copyrightStatisticsModule_aiCreatorsList_edges_node[]
    aiFansRankList: getAiFansCountRank_copyrightStatisticsModule_aiCreatorsList_edges_node[]
  }
}> = ({
  data: {
    aiSameRankList: _aiSameRankList = [],
    aiPictureRankList: _aiPictureRankList = [],
    aiFansRankList: _aiFansRankList = [],
  },
}) => {
  const {
    formatAiCreatorsIndexList,
    handleAiCreatorsIndexAll,
    fetchAiCreatorsSingle,
  } = useAiCreators()
  const { handleCreatorsIndexAll, fetchCreatorsSingle } = useCreators()
  const { handleWorksIndexAll, fetchWorksSingle } = useWorks()
  const { handleCollectionsIndexAll, fetchCollectionsingle } = useCollections()
  /** 二级时间分类切换 */
  const onTimeTabsChange = useCallback(async (timeValue, type, parentType) => {
    let res: any
    if (parentType === RANK_TAB_TYPE.AI_CREATORS) {
      res = await fetchAiCreatorsSingle(
        {
          ...defaultParams,
          date: timeValue,
        },
        type
      )
    } else if (parentType === RANK_TAB_TYPE.CREATORS) {
      res = await fetchCreatorsSingle(
        {
          ...defaultParams,
          date: timeValue,
        },
        type
      )
    } else if (parentType === RANK_TAB_TYPE.WORKS) {
      res = await fetchWorksSingle({
        ...defaultParams,
        period: timeValue,
        sortType: type,
      })
    } else if (parentType === RANK_TAB_TYPE.COLLECTIONS) {
      res = await fetchCollectionsingle({
        ...defaultParams,
        period: timeValue,
        sortType: type,
      })
    }
    !!res?.length &&
      setRankList(list => {
        return list.map(singleList => {
          if (type === singleList?.type) {
            singleList.data = res
          }
          return singleList
        })
      })
  }, [])

  const [rankList, setRankList] = useState<
    INDEX_RANK_ITEM_LIST_TYPE<getAiSameStyleRank_copyrightStatisticsModule_aiCreatorsList_edges_node>[]
  >([
    formatAiCreatorsIndexList(
      _aiSameRankList,
      aiCreatorsTabList[0].key,
      aiCreatorsTabList[0].name,
      onTimeTabsChange
    ),
    formatAiCreatorsIndexList(
      _aiPictureRankList,
      aiCreatorsTabList[1].key,
      aiCreatorsTabList[1].name,
      onTimeTabsChange
    ),
    formatAiCreatorsIndexList(
      _aiFansRankList,
      aiCreatorsTabList[2].key,
      aiCreatorsTabList[2].name,
      onTimeTabsChange
    ),
  ])

  /** 一级分类切换 */
  const onClassifyChange = useCallback(async (params: TabsItemProps) => {
    let res: any[] = []
    const parentType = params.key
    if (parentType === RANK_TAB_TYPE.AI_CREATORS) {
      res = await handleAiCreatorsIndexAll(
        {
          ...defaultParams,
          date: QueryDateEnum.SEVEN_DAYS,
        },
        onTimeTabsChange
      )
    } else if (parentType === RANK_TAB_TYPE.CREATORS) {
      res = await handleCreatorsIndexAll(
        {
          ...defaultParams,
          date: QueryDateEnum.THIRTY_DAYS,
        },
        onTimeTabsChange
      )
    } else if (parentType === RANK_TAB_TYPE.WORKS) {
      res = await handleWorksIndexAll(
        {
          ...defaultParams,
          period: ArtworkCommonSortPeriod.THIRTY_DAYS,
          sortType: ArtworkCommonSortType.TRADE_MONEY,
        },
        onTimeTabsChange
      )
    } else if (parentType === RANK_TAB_TYPE.COLLECTIONS) {
      res = await handleCollectionsIndexAll(
        {
          ...defaultParams,
          period: ArtworkCommonSortPeriod.THIRTY_DAYS,
          sortType: ArtworkCommonSortType.TRADE_MONEY,
        },
        onTimeTabsChange
      )
    }
    !!res?.length && setRankList(res)
  }, [])

  return (
    <div className="flex">
      <RankIndexTabs
        data={indexTabList}
        onChange={onClassifyChange}
        defaultValue={RANK_TAB_TYPE.AI_CREATORS}
      />
      <div className="flex flex-1 overflow-hidden">
        {rankList?.map(ele => (
          <IndexRank key={ele.parentType + '' + ele.type} {...ele} />
        ))}
      </div>
    </div>
  )
}
